(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('lab-compendium', {
                parent: 'entity',
                url: '/lab-compendium',
                data: {
                    authorities: [ROLES.ROLE_USER],
                    pageTitle: 'Lab Compendium'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-compendium/list/lab-compendium.html',
                        controller: 'LabCompendiumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }

})();
